module.exports = __webpack_public_path__ + "static/co-fes-logo-white-588f001d6efb38418703d020fb6a0fc9.png";